/**
 * 라우터 path name
 * [!] '메뉴'에서 사용하는 값을 변경할 경우 TSYS350 테이블의 PATH_NAME 컬럼값도 함께 변경해야함 (*)
 */
export default {
  PolicyConsent: 'policyConsent', // 약관동의(앱최초)
  PolicyConsentService: 'policyConsentService', // 약관동의(앱최초)
  PolicyConsentPrivacy: 'policyConsentPrivacy', // 약관동의(앱최초)
  Login: 'login', // 로그인

  Main: 'main', // 메인
  MemberSearch: 'memberSearch', // 직원검색
  Calendar: 'calendar', // 일정
  AllMenu: 'allMenu', // (전체)메뉴

  WorkTimeSta: 'workTimeSta', // 근무현황 *
  OrgGntWorkSta: 'orgGntWorkSta', // 부서원근태현황 *
  WorkOverTimeSta: 'workOverTimeSta', // 연장근무보상시간 *
  AnnualHolidaySta: 'annualHolidaySta', // 연차휴가현황 *
  MaternityHolidaySta: 'maternityHolidaySta', // 배우자출산휴가현황 *
  AnnualPlan: 'annualPlan', // 연차휴가계획목록 *
  AnnualPlanWrite: 'annualPlanWrite', // 연차휴가계획작성 *
  SelectPayGubun: 'selectPayGubun', // 급여구분선택 *

  ApprDoc: 'apprDoc', // 결재할문서 *
  MyBox: 'myBox', // 내문서함 *

  ApplicationMenu: 'applicationMenu', // 신청서메뉴
  CancelMenu: 'cancelMenu', // 취소신청서메뉴
  GntTypeMenu: 'gntTypeMenu', // 근태명 선택메뉴
  GntGubunMenu: 'gntGubunMenu', // 근태종류 선택메뉴
  Application: 'application', // 신청서 *
  StartDate: 'startDate', // 시작일선택
  EndDate: 'endDate', // 종료일선택
  StartDateAppl: 'startDateAppl', // 시작일선택(신규 신청서용)
  EndDateAppl: 'endDateAppl', // 종료일선택(신규 신청서용)
  DateAppl: 'dateAppl', // 날짜선택(신규 신청서용)
  SelectTime: 'selectTime', // 시간선택
  ApprovalLine: 'approvalLine', // 결재라인
  ExtraOptions: 'extraOptions', // 추가옵션
  ApplicationConfirm: 'applicationConfirm', // 신청서완료뷰
  ConfirmOtWorkTime: 'confirmOtWorkTime', // 연장근무신청시간확인
  SelectAlterDate: 'selectAlterDate', // 대체휴가설정
  SelectSchedule: 'selectSchedule', // 근무스케줄선택
  Vaccination: 'vaccination', // 독감예방접종신청
  VaccinationSub: 'vaccinationSub', // 독감예방접종신청 서브
  VaccinationBoxView: 'vaccinationBoxView', // 독감예방접종신청 리스트
  VaccinationDetailView: 'vaccinationDetailView', // 독감예방접종 상세
  EdusApp: 'edusApp', // 학자금신청 구분
  EdusAppBoxView: 'edusAppBoxView', // 학자금신청 리스트
  EdusAppSub: 'edusAppSub', // 학자금신청 서브
  CalendarAppl: 'calendarAppl', // 일정
  LeaAbsAppStep1: 'leaAbsAppStep1', // 휴/복직 (육아, 가족 휴직)신청 첫 페이지
  LeaAbsAppStep2: 'leaAbsAppStep2', // 휴/복직 (육아, 가족 휴직)신청 두번째 페이지
  LeaAbsAppStep3: 'leaAbsAppStep3', // 휴/복직 (육아, 가족 휴직)신청 세번째 페이지
  LeaAbsAppEtcView: 'leaAbsAppEtcView', // 휴/복직 신청 난임치료휴직, 공상휴직, 사상휴직, 신상휴직 페이지
  LeaAbsAppRehView: 'leaAbsAppRehView', // 휴/복직 신청(복직신청)
  LeaAbsBoxView: 'leaAbsBoxView', // 휴/복직 육아휴직 연장신청 기신청 리스트
  LeaAbsAppParLeaveView: 'leaAbsAppParLeaveView', // 휴/복직 육아휴직(연장) 연장신청 입력
  LeaAbsAppParLeaveAddView: 'leaAbsAppParLeaveAddView', // 휴/복직 육아휴직(추가) 연장신청 입력
  HolReplaceApp: 'holReplaceApp', // 휴일근무사전대체신청
  DateHolReplaceAppView: 'dateHolReplaceAppView', // 휴일근무사전대체신청 캘린더
  HolReplaceSubView: 'holReplaceSubView', // 휴일근무사전대체신청 서브 신청 페이지
  HolReplaceBoxView: 'holReplaceBoxView', // 휴일근무사전대체 취소 신청 리스트
  HolReplaceCancelSubView: 'HolReplaceCancelSubView', // 휴일근무사전대체 취소 신청 상세내역
  ReCertAppStep: 'reCertAppStep', // 재증명신청 첫 페이지
  ReCertTenureAppView: 'reCertTenureAppView', // 재직증명신청(영문)
  ReCertTenureEngAppView: 'reCertTenureEngAppView', //재직증명신청(영문)
  ReCertTenureTaxAppView: 'reCertTenureTaxAppView', // 원정칭수영수증, 원천징수부
  ReCertLeaveAppView: 'reCertLeaveAppView', // 휴직증명서
  ReCertGabTaxView: 'reCertGabTaxView', // 갑근세증명원
  WorkScheduleTime1: 'workScheduleTime1', // 시차출퇴근제
  WorkScheduleTimeView: 'workScheduleTimeView', // 시차출퇴근제 기준일자 캘린더
  WorkScheduleTime2: 'workScheduleTime2', // 시차출퇴근제 두번째 페이지
  WorkScheduleTime3: 'workScheduleTime3', // 시차출퇴근제 세번째 페이지
  WorkScheduleTime4: 'workScheduleTime4', // 시차출퇴근제 네번째 페이지
  SurveyBoxView: 'surveyBoxView', // 설문조사 리스트
  SurveyAnswer: 'surveyAnswer', // 설문조사 리스트
  VacationMyWorkHoliday: 'vacationMyWorkHoliday', // 휴가신청 현황
  VacationMyWorkHolidayMain: 'vacationMyWorkHolidayMain', // 휴가신청 현황 메인용
  VacationGntGubunMenuView: 'vacationGntGubunMenuView', // 휴가신청 구분 리스트
  VacationView: 'vacationView', // 휴가신청 페이지
  VacationCancelView: 'vacationCancelView', // 휴가취소 페이지

  LaborContract: 'laborContract', //근로계약서
  ConsentContract: 'consentContract', //전적동의서
  AnnualContract: 'annualContract', //연봉계약서

  NewMember: 'newMember', // 신규입사자 *
  Board: 'board', // 게시판(공지사항) *

  SettingMenu: 'settingMenu', // 설정메뉴
  PasswordChange: 'passwordChange', // 비밀번호변경(설정내부)
  ServicePolicy: 'servicePolicy', // 서비스이용약관(설정내부)
  PrivacyPolicy: 'privacyPolicy', // 개인정보처리방침(설정내부)

  Error: 'error', // 에러화면
  Alert: 'alert', // 알림?
};
